import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./video.css";
import Footer from "../componant/Footer";
import ChatComponent from "../componant/ChatComponent";

// 🔹 Icons Components
const MenuIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
  </svg>
);

const LessonIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h10v2H4z"/>
  </svg>
);

const AssignmentIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
  </svg>
);

const PDFIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
  </svg>
);

const QuizIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
    <path d="M7 7h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"/>
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M8 5v14l11-7z"/>
  </svg>
);

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
  </svg>
);

const FullscreenIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
  </svg>
);

const ExitFullscreenIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
  </svg>
);

const VolumeUpIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
  </svg>
);

const VolumeOffIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
  </svg>
);const SkipPreviousIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/>
  </svg>
);

const SkipNextIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
  </svg>
);

const ReplayIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
  </svg>
);

const SpeedIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44zm-9.79 6.84a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"/>
  </svg>
);

const TimelineIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"/>
  </svg>
);

// 🔹 Security Alert Function
const showSecurityAlert = (message) => {
  const alert = document.createElement('div');
  alert.className = 'security-alert';
  alert.innerHTML = `
    <span class="alert-icon">🛡️</span>
    <div class="alert-content">
      <div class="alert-title">حماية المحتوى</div>
      <div class="alert-message">${message}</div>
    </div>
    <button class="close-alert">×</button>
  `;
  
  document.body.appendChild(alert);
  
  alert.querySelector('.close-alert').onclick = () => {
    alert.remove();
  };
  
  setTimeout(() => {
    if (alert.parentNode) {
      alert.remove();
    }
  }, 3000);
};

// 🔹 Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Component Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-fallback">
          <div className="error-icon">⚠️</div>
          <h4>حدث خطأ في التحميل</h4>
          <p>يرجى تحديث الصفحة</p>
          <button 
            className="retry-btn"
            onClick={() => window.location.reload()}
          >
            تحديث الصفحة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// 🔹 Secure Video Player Component
// 🔹 Secure Video Player Component with Timeline
// 🔹 Secure Video Player Component with Timeline (Improved)
const SecureVideoPlayer = ({ url, title, onError }) => {
  const [hasError, setHasError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(600); // 10 minutes default
  const [playbackRate, setPlaybackRate] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());
  
  const iframeRef = useRef(null);
  const videoContainerRef = useRef(null);
  const timelineRef = useRef(null);
  const playPauseRef = useRef(null);
  const fullscreenRef = useRef(null);
  const volumeRef = useRef(null);
  const timeIntervalRef = useRef(null);
  const lastSrcRef = useRef("");
  
  // 🔹 Extract video ID from URL
  const extractYouTubeId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : null;
  };

  const extractGoogleDriveId = (url) => {
    const regExp = /\/d\/([^\/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  const extractVimeoId = (url) => {
    const regExp = /(?:vimeo\.com\/|video\/)(\d+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  // 🔹 Get secure video URL WITHOUT auto-reloading
  const getSecureVideoUrl = (url, autoplay = false, mute = false) => {
    if (!url) return null;

    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = extractYouTubeId(url);
      if (videoId) {
        return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&controls=1&showinfo=0`;
      }
    }
    
    // Google Drive
    if (url.includes('drive.google.com')) {
      const fileId = extractGoogleDriveId(url);
      if (fileId) {
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }
    }
    
    // Vimeo
    if (url.includes('vimeo.com')) {
      const videoId = extractVimeoId(url);
      if (videoId) {
        return `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0`;
      }
    }

    // Direct video links
    if (url.match(/\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv)$/i)) {
      return url;
    }

    return url;
  };

  // 🔹 Simulate time progression when playing (LOCAL SIMULATION ONLY)
  useEffect(() => {
    if (isPlaying) {
      const startTime = Date.now();
      const startVideoTime = currentTime;
      
      timeIntervalRef.current = setInterval(() => {
        const elapsedSeconds = (Date.now() - startTime) / 1000;
        const newTime = startVideoTime + (elapsedSeconds * playbackRate);
        
        if (newTime >= duration) {
          setCurrentTime(duration);
          setIsPlaying(false);
          showSecurityAlert("🎉 اكتمل الفيديو!");
        } else {
          setCurrentTime(newTime);
        }
      }, 100);
    } else {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
        timeIntervalRef.current = null;
      }
    }
    
    return () => {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
      }
    };
  }, [isPlaying, playbackRate, duration]);

  // 🔹 Handle video seeking (SIMULATION ONLY - لا نغير الـ iframe)
  const seekTo = (newTime) => {
    const clampedTime = Math.max(0, Math.min(duration, newTime));
    setCurrentTime(clampedTime);
    setLastUpdateTime(Date.now());
    
    // لا نقوم بإعادة تحميل الـ iframe - نعتمد على المحاكاة المحلية فقط
    showSecurityAlert(`⏱️ تم الانتقال إلى ${formatTime(clampedTime)}`);
  };

  // 🔹 Toggle Play/Pause
  const togglePlayPause = () => {
    if (!videoReady) return;
    
    const newIsPlaying = !isPlaying;
    setIsPlaying(newIsPlaying);
    
    if (newIsPlaying) {
      // بدأ التشغيل - نرسل رسالة للـ iframe لو كان ذلك ممكناً
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          // محاولة تشغيل الفيديو عبر postMessage
          iframeRef.current.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
      } catch (e) {
        console.log("Cannot control iframe directly");
      }
    } else {
      // توقف التشغيل
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          iframeRef.current.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
      } catch (e) {
        console.log("Cannot control iframe directly");
      }
    }
  };

  // 🔹 Skip forward/backward
  const skip = (seconds) => {
    seekTo(currentTime + seconds);
  };

  // 🔹 Handle timeline click/drag
  const handleTimelineClick = (e) => {
    if (!timelineRef.current || !videoReady) return;
    
    const timeline = timelineRef.current;
    const rect = timeline.getBoundingClientRect();
    const clickX = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const percentage = clickX / rect.width;
    const newTime = percentage * duration;
    
    seekTo(newTime);
    
    // محاولة الانتقال في الفيديو الحقيقي
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        const seconds = Math.floor(newTime);
        iframeRef.current.contentWindow.postMessage(`{"event":"command","func":"seekTo","args":[${seconds}, true]}`, '*');
      }
    } catch (e) {
      console.log("Cannot seek in iframe");
    }
  };

  const handleTimelineMouseDown = (e) => {
    setIsDragging(true);
    setIsPlaying(false); // إيقاف التشغيل أثناء السحب
    
    const handleMouseMove = (moveEvent) => {
      if (isDragging) {
        handleTimelineClick(moveEvent);
      }
    };
    
    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // 🔹 Format time (seconds to MM:SS)
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // 🔹 Change playback speed (SIMULATION ONLY)
  const changeSpeed = () => {
    const speeds = [0.5, 0.75, 1, 1.25, 1.5, 2];
    const currentIndex = speeds.indexOf(playbackRate);
    const nextIndex = (currentIndex + 1) % speeds.length;
    const newSpeed = speeds[nextIndex];
    setPlaybackRate(newSpeed);
    
    // إعادة ضبط المحاكاة مع السرعة الجديدة
    if (isPlaying) {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
      }
      
      const startTime = Date.now();
      const startVideoTime = currentTime;
      
      timeIntervalRef.current = setInterval(() => {
        const elapsedSeconds = (Date.now() - startTime) / 1000;
        const newTime = startVideoTime + (elapsedSeconds * newSpeed);
        
        if (newTime >= duration) {
          setCurrentTime(duration);
          setIsPlaying(false);
        } else {
          setCurrentTime(newTime);
        }
      }, 100);
    }
    
    showSecurityAlert(`⚡ سرعة التشغيل: ${newSpeed}x`);
  };

  // 🔹 Toggle Fullscreen
  const toggleFullscreen = () => {
    if (!document.fullscreenEnabled) {
      showSecurityAlert("وضع ملء الشاشة غير مدعوم في هذا المتصفح");
      return;
    }
    
    const videoElement = videoContainerRef.current;
    if (!videoElement) return;
    
    if (!isFullscreen) {
      // Enter fullscreen
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.webkitRequestFullscreen) {
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) {
        videoElement.msRequestFullscreen();
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  // 🔹 Toggle Mute/Unmute
  const toggleMute = () => {
    if (!videoReady) return;
    
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(`{"event":"command","func":"${newMuted ? 'mute' : 'unMute'}","args":""}`, '*');
      }
    } catch (e) {
      console.log("Cannot control iframe audio");
    }
  };

  // 🔹 Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = 
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;
      
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  // 🔹 Handle keyboard shortcuts for controls
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Space for play/pause
      if (e.code === 'Space' && !e.target.closest('input, textarea')) {
        e.preventDefault();
        togglePlayPause();
      }
      // F for fullscreen
      if (e.code === 'KeyF') {
        e.preventDefault();
        toggleFullscreen();
      }
      // M for mute
      if (e.code === 'KeyM') {
        e.preventDefault();
        toggleMute();
      }
      // Left arrow for rewind
      if (e.code === 'ArrowLeft') {
        e.preventDefault();
        skip(-10);
      }
      // Right arrow for forward
      if (e.code === 'ArrowRight') {
        e.preventDefault();
        skip(10);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPlaying, isFullscreen, isMuted, videoReady, currentTime]);

  // 🔹 Handle Protection Click - Prevent all interactions
  const handleProtectionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.type === 'contextmenu') {
      showSecurityAlert("❌ النسخ والتحديد غير مسموح به");
      return false;
    }
    
    return false;
  };

  // 🔹 Handle drag events
  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  // 🔹 Listen for messages from iframe
  useEffect(() => {
    const handleMessage = (event) => {
      // يمكننا استقبال معلومات من الـ iframe هنا إذا كان يدعم postMessage
      console.log("Message from iframe:", event.data);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleIframeError = () => {
    setHasError(true);
    setVideoReady(false);
    if (onError) onError();
    showSecurityAlert("❌ حدث خطأ في تحميل الفيديو");
  };

  const handleIframeLoad = () => {
    setVideoReady(true);
    setHasError(false);
    console.log("Video iframe loaded successfully");
    
    // محاولة جعل الـ iframe يسمح بالتحكم
    try {
      if (iframeRef.current) {
        // جعل الـ iframe يسمح ببعض الخصائص
        iframeRef.current.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        
        // YouTube يحتاج إلى إضافة enablejsapi=1
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
          const currentSrc = iframeRef.current.src;
          if (!currentSrc.includes('enablejsapi=1')) {
            const newSrc = currentSrc.includes('?') 
              ? `${currentSrc}&enablejsapi=1&origin=${window.location.origin}`
              : `${currentSrc}?enablejsapi=1&origin=${window.location.origin}`;
            
            if (newSrc !== lastSrcRef.current) {
              lastSrcRef.current = newSrc;
              iframeRef.current.src = newSrc;
            }
          }
        }
      }
    } catch (e) {
      console.log("Cannot modify iframe properties");
    }
  };

  if (!url || hasError) {
    return (
      <div className="no-video-state">
        <div className="no-video-content">
          <div className="no-video-icon">🎬</div>
          <h3>لا يوجد فيديو متاح</h3>
          <p>يبدو أن الفيديو غير متوفر حالياً</p>
        </div>
      </div>
    );
  }

  const progressPercentage = (currentTime / duration) * 100;
  const secureUrl = getSecureVideoUrl(url);

  return (
    <div className="secure-video-wrapper">
      {/* Video Container with Protection Frame */}
      <div 
        ref={videoContainerRef}
        className="video-protected-container"
        onContextMenu={handleProtectionClick}
        onDragStart={handleDragStart}
        onMouseDown={handleProtectionClick}
        onTouchStart={handleProtectionClick}
        onClick={(e) => {
          // Allow click to pass through to buttons
          if (!e.target.closest('.video-control-btn, .timeline-bar, .skip-btn, .speed-btn')) {
            handleProtectionClick(e);
          }
        }}
      >
        {/* Full Protection Overlay */}
        <div className="protection-overlay"></div>
        
        {/* Transparent Protection Grid */}
        <div className="protection-grid">
          <div className="grid-line horizontal"></div>
          <div className="grid-line vertical"></div>
        </div>
        
        {/* Subtle Watermark */}
        <div className="protection-watermark">
          <span className="watermark-text">محتوى محمي</span>
          <span className="watermark-icon">🛡️</span>
        </div>
        
        {/* Video Iframe */}
        <div className="video-iframe-container">
          <iframe
            ref={iframeRef}
            title={title || "المحاضرة التعليمية"}
            src={secureUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups"
            referrerPolicy="strict-origin-when-cross-origin"
            loading="lazy"
            className="protected-video-iframe"
            onError={handleIframeError}
            onLoad={handleIframeLoad}
          />
        </div>
      </div>
      
      {/* Video Controls - Positioned UNDER the video */}
      <div className="video-controls-container">
        <div className="controls-header">
          <h4 className="controls-title">
            <TimelineIcon />
            تحكم في الفيديو
          </h4>
          <span className="protection-badge">
            {isPlaying ? '▶️ تشغيل' : '⏸️ إيقاف'}
          </span>
        </div>
        
        {/* Timeline Section */}
        <div className="timeline-section">
          <div className="timeline-header">
            <span className="time-current">{formatTime(currentTime)}</span>
            <span className="timeline-label">شريط التقدم</span>
            <span className="time-total">{formatTime(duration)}</span>
          </div>
          
          {/* Timeline Bar */}
          <div 
            ref={timelineRef}
            className="timeline-bar"
            onClick={handleTimelineClick}
            onMouseDown={handleTimelineMouseDown}
          >
            <div className="timeline-background"></div>
            <div 
              className="timeline-progress" 
              style={{ width: `${progressPercentage}%` }}
            ></div>
            <div 
              className="timeline-thumb" 
              style={{ left: `${progressPercentage}%` }}
            ></div>
            
            {/* Time Markers */}
            <div className="time-markers">
              {[0, 25, 50, 75, 100].map(percent => (
                <div 
                  key={percent} 
                  className="time-marker" 
                  style={{ left: `${percent}%` }}
                >
                  <span className="marker-label">{formatTime((percent / 100) * duration)}</span>
                </div>
              ))}
            </div>
            
            {/* Progress Points */}
            <div className="progress-points">
              <div 
                className="progress-point" 
                style={{ left: '25%' }}
                title="ربع الفيديو"
              ></div>
              <div 
                className="progress-point" 
                style={{ left: '50%' }}
                title="نصف الفيديو"
              ></div>
              <div 
                className="progress-point" 
                style={{ left: '75%' }}
                title="ثلاثة أرباع الفيديو"
              ></div>
            </div>
          </div>
          
          {/* Timeline Controls */}
          <div className="timeline-controls">
            <div className="skip-controls">
              <button 
                className="skip-btn"
                onClick={() => skip(-10)}
                title="رجوع 10 ثواني"
                disabled={!videoReady || currentTime <= 0}
              >
                <ReplayIcon />
                <span>10s</span>
              </button>
              
              <button 
                className="skip-btn"
                onClick={() => skip(-30)}
                title="رجوع 30 ثانية"
                disabled={!videoReady || currentTime <= 0}
              >
                <SkipPreviousIcon />
                <span>30s</span>
              </button>
            </div>
            
            <div className="speed-control">
              <button 
                className="speed-btn"
                onClick={changeSpeed}
                title="سرعة التشغيل"
                disabled={!videoReady}
              >
                <SpeedIcon />
                <span>{playbackRate}x</span>
              </button>
            </div>
            
            <div className="skip-controls">
              <button 
                className="skip-btn"
                onClick={() => skip(30)}
                title="تقديم 30 ثانية"
                disabled={!videoReady || currentTime >= duration}
              >
                <span>30s</span>
                <SkipNextIcon />
              </button>
              
              <button 
                className="skip-btn"
                onClick={() => skip(60)}
                title="تقديم دقيقة"
                disabled={!videoReady || currentTime >= duration}
              >
                <span>60s</span>
                <SkipNextIcon />
              </button>
            </div>
          </div>
        </div>
        
        {/* Basic Controls Grid */}
        <div className="controls-grid">
          {/* Play/Pause Button */}
          <button 
            ref={playPauseRef}
            className="video-control-btn play-pause-btn"
            onClick={togglePlayPause}
            disabled={!videoReady}
            title={isPlaying ? "إيقاف مؤقت" : "تشغيل"}
            aria-label={isPlaying ? "إيقاف الفيديو" : "تشغيل الفيديو"}
          >
            <span className="control-icon">
              {isPlaying ? <PauseIcon /> : <PlayIcon />}
            </span>
            <span className="control-text">
              {isPlaying ? "إيقاف" : "تشغيل"}
            </span>
          </button>
          
          {/* Mute/Unmute Button */}
          <button 
            ref={volumeRef}
            className="video-control-btn volume-btn"
            onClick={toggleMute}
            disabled={!videoReady}
            title={isMuted ? "تشغيل الصوت" : "كتم الصوت"}
            aria-label={isMuted ? "تشغيل الصوت" : "كتم الصوت"}
          >
            <span className="control-icon">
              {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
            </span>
            <span className="control-text">
              {isMuted ? "تشغيل الصوت" : "كتم الصوت"}
            </span>
          </button>
          
          {/* Fullscreen Button */}
          <button 
            ref={fullscreenRef}
            className="video-control-btn fullscreen-btn"
            onClick={toggleFullscreen}
            title={isFullscreen ? "تصغير الشاشة" : "ملء الشاشة"}
            aria-label={isFullscreen ? "تصغير الشاشة" : "ملء الشاشة"}
            disabled={!videoReady}
          >
            <span className="control-icon">
              {isFullscreen ? <ExitFullscreenIcon /> : <FullscreenIcon />}
            </span>
            <span className="control-text">
              {isFullscreen ? "تصغير" : "تكبير"}
            </span>
          </button>
        </div>
        
        {/* Video Status */}
        <div className="video-status">
          <div className="status-item">
            <span className={`status-dot ${videoReady ? 'ready' : 'loading'}`}></span>
            <span className="status-text">
              {videoReady ? 'الفيديو جاهز' : 'جاري تحميل الفيديو...'}
            </span>
          </div>
          <div className="status-item">
            <span className="protection-info">
              <span className="protection-icon">🔒</span>
              النسخ والتحديد معطل
            </span>
          </div>
          <div className="status-item">
            <span className="time-info">
              <span className="time-icon">⏱️</span>
              {formatTime(currentTime)} / {formatTime(duration)}
              {isPlaying && <span className="playing-indicator"> ▶</span>}
            </span>
          </div>
        </div>
        
        {/* Help Text */}
        <div className="controls-help">
          <p className="help-text">
            ⚡ نظام محاكاة التحكم - يتم محاكاة التوقيت محلياً للتحكم السلس
          </p>
        </div>
        
        {/* Keyboard Shortcuts Info */}
        <div className="shortcuts-info">
          <span className="shortcut-item">
            <kbd>Space</kbd> تشغيل/إيقاف
          </span>
          <span className="shortcut-item">
            <kbd>← →</kbd> تنقل 10 ثواني
          </span>
          <span className="shortcut-item">
            <kbd>F</kbd> ملء الشاشة
          </span>
          <span className="shortcut-item">
            <kbd>M</kbd> كتم الصوت
          </span>
        </div>
      </div>
    </div>
  );
};
// 🔹 Resource Card Component
const ResourceCard = ({ icon: Icon, title, description, buttonLabel, href, onClick, disabled = false, buttonType = "default" }) => {
  const navigate = useNavigate();
  
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      showSecurityAlert("هذا المورد غير متاح حالياً");
      return;
    }
    
    if (onClick) {
      onClick(e);
    } else if (href) {
      navigate(href);
    }
  };

  return (
    <div className={`resource-card ${disabled ? 'disabled' : ''}`}>
      <div className="card-header">
        <div className="card-icon">
          <Icon />
        </div>
        <div className="card-title">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
      <button
        className={`resource-btn ${buttonType} ${disabled ? 'disabled-btn' : ''}`}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonType === "quiz" && <QuizIcon />}
        {buttonType === "pdf" && <PDFIcon />}
        {buttonType === "assignment" && <AssignmentIcon />}
        <span>{buttonLabel}</span>
      </button>
    </div>
  );
};

// 🔹 Main Video Component
export default function Video() {
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [videoData, setVideoData] = useState({
    url: "",
    title: "فيديو المحاضرة",
    description: "لا يوجد وصف متاح"
  });
  const [lessonTitle, setLessonTitle] = useState("المحاضرة التعليمية");
  const [quizUrl, setQuizUrl] = useState("");
  const [fetchErrors, setFetchErrors] = useState({
    video: false,
    quiz: false,
    lesson: false
  });

  const navigate = useNavigate();

  // 🔹 Security Protection
  useEffect(() => {
    const handleContextMenu = (e) => {
      const target = e.target;
      if (target && target.closest && typeof target.closest === 'function') {
        const videoArea = target.closest('.video-protected-container, .protected-video-iframe');
        if (videoArea) {
          e.preventDefault();
          showSecurityAlert("❌ النسخ والتحديد غير مسموح به");
          return false;
        }
      }
      return true;
    };

    const handleSelectStart = (e) => {
      const target = e.target;
      if (target && target.closest && typeof target.closest === 'function') {
        const videoArea = target.closest('.video-protected-container');
        if (videoArea) {
          e.preventDefault();
          return false;
        }
      }
      return true;
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('selectstart', handleSelectStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  // 🔹 Fetch Data
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const lessonId = localStorage.getItem("lesson_id");

        if (!token || !lessonId) {
          navigate("/login");
          return;
        }

        const headers = { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };

        // Fetch Lesson Info
        try {
          const lessonRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/lessons/${lessonId}`,
            { headers }
          );
          
          if (isMounted && lessonRes.data) {
            setLessonTitle(lessonRes.data.title || "المحاضرة التعليمية");
            setFetchErrors(prev => ({ ...prev, lesson: false }));
          }
        } catch (lessonError) {
          console.log("Could not fetch lesson title");
          if (isMounted) {
            setFetchErrors(prev => ({ ...prev, lesson: true }));
          }
        }

        // Fetch Video Data
        try {
          const videoRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/videos/lesson/${lessonId}`,
            { headers }
          );

          if (isMounted && videoRes.data?.length > 0) {
            const video = videoRes.data[0];
            setVideoData({
              url: video.url || "",
              title: video.title || "فيديو المحاضرة",
              description: video.description || "لا يوجد وصف متاح",
            });
            setFetchErrors(prev => ({ ...prev, video: false }));
          } else {
            if (isMounted) {
              setFetchErrors(prev => ({ ...prev, video: true }));
            }
          }
        } catch (videoError) {
          console.log("Could not fetch video data:", videoError);
          if (isMounted) {
            setFetchErrors(prev => ({ ...prev, video: true }));
          }
        }

        // Fetch Quiz Data
        try {
          const quizRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/mcqs/lesson/${lessonId}`,
            { headers }
          );

          if (isMounted && quizRes.data?.mcqs?.length > 0) {
            setQuizUrl(quizRes.data.mcqs[0].url || "");
            setFetchErrors(prev => ({ ...prev, quiz: false }));
          } else {
            setQuizUrl("");
            setFetchErrors(prev => ({ ...prev, quiz: true }));
          }
        } catch (quizError) {
          console.log("No quiz available for this lesson:", quizError);
          if (isMounted) {
            setQuizUrl("");
            setFetchErrors(prev => ({ ...prev, quiz: true }));
          }
        }

      } catch (error) {
        console.error("❌ Error fetching data:", error);
        if (isMounted) {
          showSecurityAlert("حدث خطأ في تحميل المحتوى");
        }
      } finally {
        if (isMounted) {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  // 🔹 Handle Logout
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (token) {
        await axios.post(
          "https://leader-acadmy.hwnix.com/api/logout",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (error) {
      console.error("Logout Failed:", error);
    } finally {
      localStorage.clear();
      navigate("/Login");
    }
  };

  // 🔹 Render Loading State
  if (loading) {
    return (
      <div className="video-page loading-page">
        <div className="loading-container">
          <div className="loading-spinner-large"></div>
          <p>جاري تحميل المحتوى...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="video-page student-page">
        {/* Security Background */}
        <div className="security-background">
          <div className="security-pattern"></div>
        </div>

        {/* Header */}
        <header className="student-header">
          <div className="header-container">
            <div className="header-left">
             
              
              <div className="brand-info">
                <div className="brand-logo">🎓</div>
                <div className="brand-text">
                  {lessonTitle && (
                    <p className="current-lesson">{lessonTitle}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="header-right">
              <div className="security-indicator">
                <span className="security-icon">🛡️</span>
                <span className="security-text">محتوى آمن</span>
              </div>
            </div>
          </div>
        </header>

        {/* Side Menu */}
        <div 
          className={`menu-overlay ${menuOpen ? 'active' : ''}`} 
          onClick={() => setMenuOpen(false)} 
        />
        
        <nav className={`student-menu ${menuOpen ? 'open' : ''}`}>
          <div className="menu-header">
            <h3>القائمة الرئيسية</h3>
            <button 
              className="menu-close" 
              onClick={() => setMenuOpen(false)}
              aria-label="إغلاق القائمة"
            >
              <CloseIcon />
            </button>
          </div>
          
          <div className="menu-items">
            <button 
              className="menu-item" 
              onClick={() => { navigate("/"); setMenuOpen(false); }}
            >
              <HomeIcon />
              <span>الرئيسية</span>
            </button>
            
            <button 
              className="menu-item" 
              onClick={() => { navigate("/ProfileCard"); setMenuOpen(false); }}
            >
              <LessonIcon />
              <span>المحاضرات</span>
            </button>
            
            <button 
              className="menu-item logout" 
              onClick={handleLogout}
            >
              <span className="logout-icon">🚪</span>
              <span>تسجيل الخروج</span>
            </button>
          </div>
        </nav>

        {/* Main Content */}
        <main className="student-main">
          {/* Video Section */}
          <section className="video-display-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">🎬</span>
                الفيديو التعليمي
                <span className="security-badge">🛡️ محمي</span>
              </h2>
              <div className="video-warning">
                <span className="warning-icon">⚠️</span>
                <span>النسخ والتحديد محظور</span>
              </div>
            </div>

            {/* Video Display Container */}
            <div className="video-display-container">
              {fetchErrors.video ? (
                <div className="video-error-state">
                  <div className="error-icon">⚠️</div>
                  <h3>لا يوجد فيديو متاح</h3>
                  <p>يبدو أن الفيديو غير متوفر حالياً</p>
                  <button 
                    className="retry-btn"
                    onClick={() => window.location.reload()}
                  >
                    إعادة المحاولة
                  </button>
                </div>
              ) : (
                <SecureVideoPlayer 
                  url={videoData.url} 
                  title={videoData.title}
                  onError={() => setFetchErrors(prev => ({ ...prev, video: true }))}
                />
              )}
            </div>

            {/* Video Info */}
            {!fetchErrors.video && videoData.url && (
              <div className="video-info-card">
                <h3 className="video-title">{videoData.title}</h3>
                <p className="video-description">{videoData.description}</p>
                <div className="video-meta">
                  <span className="meta-item">
                    <span className="meta-icon">🎬</span>
                    تحكم خارجي آمن
                  </span>
                  <span className="meta-item">
                    <span className="meta-icon">🔒</span>
                    حماية كاملة ضد النسخ
                  </span>
                  <span className="meta-item">
                    <span className="meta-icon">📱</span>
                    متوافق مع جميع الشاشات
                  </span>
                </div>
              </div>
            )}
          </section>

          {/* Resources Section */}
          <section className="resources-section">
            <h2 className="section-title">
              <span className="title-icon">📚</span>
              المصادر التعليمية
            </h2>
            
            <div className="resources-grid">
              <ResourceCard
                icon={AssignmentIcon}
                title="الواجبات"
                description="الواجبات المنزلية"
                buttonLabel="عرض الواجبات"
                href="/AssignmentsPage"
                buttonType="assignment"
              />

              <ResourceCard
                icon={PDFIcon}
                title="الملازم"
                description="الملفات التعليمية"
                buttonLabel="عرض الملازم"
                href="/PdfList"
                buttonType="pdf"
              />

              <div className="resource-card">
                <div className="card-header">
                  <div className="card-icon">
                    <QuizIcon />
                  </div>
                  <div className="card-title">
                    <h3>الاختبارات</h3>
                    <p>اختبارات تفاعلية</p>
                  </div>
                </div>
                
                {quizUrl && quizUrl.trim() ? (
                  <a 
                    href={quizUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="resource-btn quiz-btn"
                  >
                    <QuizIcon />
                    <span>بدء الاختبار</span>
                  </a>
                ) : (
                  <button 
                    className="resource-btn disabled-btn"
                    onClick={() => showSecurityAlert("لا يوجد اختبار متاح حالياً")}
                  >
                    <span>غير متاح</span>
                  </button>
                )}
              </div>
            </div>
          </section>

          {/* Chat Section */}
          <section className="chat-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">💬</span>
                التواصل مع المعلم
              </h2>
            </div>
            <div className="chat-container">
              <ErrorBoundary>
                <ChatComponent />
              </ErrorBoundary>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </ErrorBoundary>
  );
}